//默认登录公司key
export const CorporationKey = '6A75EC49-2093-4B89-950F-65E6E72746DA';

//默认登录系统key
export const SystemKey = '6E746ED0-12E9-4002-9887-D84A19142304';

//默认登录用户key
export const UserId = '6A75EC49-2093-4B89-950F-65E6E72746BA';

//默认登录用户名称
export const UserName = '张三';

//默认登录用户密码
export const Password = '1';

//默认登录验证码
export const defaultRouter="/obtain"